import axios from 'axios';

const careApi = axios.create({
  baseURL: import.meta.env.VITE_CARE_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
});

export interface OfferDetails {
  offer_status: 'active' | 'expired' | 'accepted';
  provider_name: string;
  practice_name: string;
  slot_time: string | null;
  slot_duration_minutes: number;
  appointment_type_id: string | null;
  backfill_id: number;
}

export interface RespondPayload {
  backfill_id: number;
  accepted: boolean;
}

export interface RespondResult {
  status: string;
  message: string;
}

export const getOfferDetails = (token: string, backfillId: string) =>
  careApi.get<OfferDetails>(
    `/v3/outreach/self-service/${token}/offer/${backfillId}`
  );

export const respondToOffer = (token: string, data: RespondPayload) =>
  careApi.post<RespondResult>(
    `/v3/outreach/self-service/${token}/respond`,
    data
  );
